import { EPermissionGroup } from 'common/permissions.types';
import { FeatureFlaggedPermissions } from 'utils/permissionsUtil';

export enum ESideBarChipType {
  COMING_SOON = 'coming_soon',
  NEW = 'new',
  LOCKED = 'locked',
  BETA = 'beta'
}

export enum ESidebarGroupKey {
  Management = 'Management',
  Sdk = 'SDK',
  Studio = 'Studio',
  Offers = 'Offers',
  Dashboard = 'Dashboard',
  Projects = 'Projects',
  Starred = 'Starred',
  PortalStudio = 'Portal Studio',
  Stores = 'Stores'
}

export interface SideBarItem {
  title: string;
  url: string;
  icon: string | React.ReactNode;
  permissions?: EPermissionGroup[];
  matchAnyPermission?: boolean;
  featureFlaggedPermissions?: FeatureFlaggedPermissions;
  chip?: ESideBarChipType;
  isDisabled?: boolean;
  docsLink?: string;
  onClick?: (e: React.MouseEvent) => void;
  defaultTab?: Record<string, string>;
  id?: string;
}

export interface SideBarGroup {
  title: ESidebarGroupKey;
  items: SideBarItem[];
  isCollapsable?: boolean;
}

export enum ESideBarContext {
  COMPANY = 'company',
  PROJECT = 'project',
  PORTAL = 'portal',
  PORTAL_LEVEL_STORE = 'store'
}

export interface ESideBarChipConfig {
  styles: string;
  title: string;
  disabledStateStyles?: string;
  tooltip?: string;
}

// New types for enhanced feature flag structure
export interface FeatureFlagConfig {
  portals?: string; // comma-separated portal IDs
  projects?: string; // comma-separated project IDs
  [key: string]: any; // allow for additional config properties
}

export interface FeatureFlagData {
  treatment: ESideBarChipType;
  config?: FeatureFlagConfig;
}

export type CompanyFeatureFlags = Record<string, FeatureFlagData | boolean>;
